<div class="d-flex flex-column gap-4" [class.opacity-50]="disabled">
  <div class="d-flex align-items-center">
    <div class="responsive-card-title flex-grow-1" i18n>Spousal Information</div>
    <app-edit-button [disabled]="disabled" (clicked)="editClicked.emit()" />
  </div>
  <div class="entry-grid">
    <app-review-entry label="Spouse First Name" i18n-label [value]="spouse?.firstName" />
    <app-review-entry label="Spouse Middle Name" i18n-label [value]="spouse?.middleName" />
    <app-review-entry label="Spouse Last Name" i18n-label [value]="spouse?.lastName" />
    <app-sin-review-entry [sin]="spouse?.socialInsuranceNumber" [disabled]="disabled" />
    <app-review-entry label="Date of Birth" i18n-label [value]="spouse?.birthDate | date : 'MMM d, y'" />
    <app-review-entry label="Email Address" i18n-label [value]="spouse?.email" />
    <app-review-entry label="Phone Number" i18n-label [value]="spouse?.formattedPhoneNumber" />
    <div class="entry-grid-spacer" aria-hidden="true"></div>
    <app-review-entry label="Country" i18n-label [value]="spouse?.address?.country?.name" />
    <app-review-entry label="Address Line 1" i18n-label [value]="spouse?.address?.addressLine1" />
    <app-review-entry label="Address Line 2" i18n-label [value]="spouse?.address?.addressLine2" />
    <app-review-entry label="Address Line 3" i18n-label [value]="spouse?.address?.addressLine3" />
    <app-review-entry label="City/Town" i18n-label [value]="spouse?.address?.city" />
    <app-review-entry label="Province/State/Region" i18n-label [value]="spouse?.address?.state?.name" />
    <app-review-entry label="Postal Code/ZIP" i18n-label [value]="spouse?.address?.postalCode" />
  </div>
</div>
